var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDatePickerCloseIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.78571 0.214286C9.5 -0.0714286 9.07143 -0.0714286 8.78572 0.214286L5 4L1.21429 0.214286C0.928571 -0.0714286 0.5 -0.0714286 0.214286 0.214286C-0.0714286 0.5 -0.0714286 0.928571 0.214286 1.21429L4 5L0.214286 8.78572C-0.0714286 9.07143 -0.0714286 9.5 0.214286 9.78571C0.357143 9.92857 0.5 10 0.714286 10C0.928571 10 1.07143 9.92857 1.21429 9.78571L5 6L8.78572 9.78571C8.92857 9.92857 9.14286 10 9.28571 10C9.42857 10 9.64286 9.92857 9.78571 9.78571C10.0714 9.5 10.0714 9.07143 9.78571 8.78572L6 5L9.78571 1.21429C10.0714 0.928571 10.0714 0.5 9.78571 0.214286Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatePickerCloseIcon);
export default __webpack_public_path__ + "static/media/DatePickerCloseIcon.c5b20495.svg";
export { ForwardRef as ReactComponent };